import {ApiClient, Endpoint} from "@eryxcoop/appyx-comm";
import GetOrdersResponse from "./functionalities/orders/history/GetOrdersResponse";
import LoginResponse from "./functionalities/login/LoginResponse";
import GetPricedArticleResponse from "./functionalities/products/detail/GetPricedArticleResponse";
import GetArticlePriceListResponse from "./functionalities/products/article_price_list/GetArticlePriceListResponse";
import GetArticlesCategoriesResponse from "./functionalities/products/category/GetArticlesCategoriesResponse";
import GetCategoriesPricedArticlesResponse
    from "./functionalities/products/category/GetCategoriesPricedArticlesResponse";
import AddArticlesToOrderEndpoint from "./functionalities/orders/AddArticlesToOrderEndpoint";
import OrderResponse from "./functionalities/orders/OrderResponse";
import UsersDeliverySitesResponse from "./functionalities/orders/UsersDeliverySitesResponse";
import GetEnabledDeliveryDatesResponse from "./functionalities/orders/GetEnabledDeliveryDatesResponse";
import OrderPricesResponse from "./functionalities/orders/OrderPricesResponse";
import CheckingAccountResponse from "./functionalities/checking_account/CheckingAccountResponse";
import DeleteOrdersArticleEndpoint from "./functionalities/orders/DeleteOrdersArticleEndpoint";
import MarkOrderAsInitialEndpoint from "./functionalities/orders/MarkOrderAsInitialEndpoint";
import MarkOrderAsPendingEndpoint from "./functionalities/orders/MarkOrderAsPendingEndpoint";
import CreateOrderEndpoint from "./functionalities/orders/CreateOrderEndpoint";
import EditOrderEndpoint from "./functionalities/orders/EditOrderEndpoint";
import MarketplaceSearchResponse from "./functionalities/products/search/MarketplaceSearchResponse";
import EditPurchaseOrderNumberEndpoint from "./functionalities/orders/EditPurchaseOrderNumberEndpoint";
import ExistsSameOrderResponse from "./functionalities/orders/existsSameOrderResponse";
import EditOrderErrorResponse from "./functionalities/orders/EditOrderErrorResponse";
import DeletedOrderErrorResponse from "./functionalities/orders/DeletedOrderErrorResponse";
import OrderWithAuthorizationResponse from "./functionalities/orders/OrderWithAuthorizationResponse";
import CustomerTaxProfileResponse from "./functionalities/customer/CustomerTaxProfileResponse";
import AdvancePaymentProofResponse from "./functionalities/cart_checkout/AdvancePaymentProofResponse";
import UserWithRolesAndPermissionsGrantedResponse from "./functionalities/user/UserWithRolesAndPermissionsGrantedResponse";
import AdvancePaymentProofErrorResponse from "./functionalities/orders/AdvancePaymentProofErrorResponse";
import AskMarketplaceAssistantResponse from "./functionalities/chat_widget/AskMarketplaceAssistantResponse";


export default class SaporeApiClient extends ApiClient {
    constructor(    requester,
                    authenticationMethod,
                    application,
                    apiResponseHandler = undefined,
                    onExceptionDo = (exception) => {
                        throw exception;
                    },
    ) {
        super(requester, apiResponseHandler, onExceptionDo);
        this._authenticationMethod = authenticationMethod;
        this._application = application;
    }

    login(email, password, responseHandler) {
        const endpoint = new Endpoint({
            url: "marketplace/login",
            method: "POST",
            ownResponses: [LoginResponse],
            needsAuthorization: true
        });
        return this.callEndpoint(endpoint, {email, password}, responseHandler);
    }

    async signInOnAuthenticationMethod(email, password) {
        const response = await this._authenticationMethod.signIn(email, password);
        if(!response.hasErrors()) {
            this._application.session().addToken(response.token())
        }
        return response

    }

    getOrders(responseHandler, customer) {
        const endpoint = new Endpoint({
            url: "customer/orders",
            method: "GET",
            ownResponses: [GetOrdersResponse],
            needsAuthorization: true
        });
        return this.callEndpoint(endpoint, {'business_name' : customer.businessName}, responseHandler);
    }

    getArticle(articleId, customersBusinessName, responseHandler) {
        const endpoint = new Endpoint({
            url: `priced-article/${articleId}`,
            method: "GET",
            ownResponses: [GetPricedArticleResponse],
            needsAuthorization: true
        });
        return this.callEndpoint(endpoint, {'customers_business_name': customersBusinessName}, responseHandler);
    }

    searchArticles(articlesOrCategoryName, customer, responseHandler){
        const endpoint = new Endpoint({
            url: `products/search`,
            method: 'GET',
            ownResponses: [MarketplaceSearchResponse],
            needsAuthorization: true
        })
        return this.callEndpoint(endpoint, {'searched_string':articlesOrCategoryName, 'customer_business_name': customer.businessName}, responseHandler)
    }

    addProductToCart(orderNumber, article, responseHandler) {
        const endpoint = new AddArticlesToOrderEndpoint({
            url: "order/articles/add-or-update",
            method: "POST",
            ownResponses: [OrderResponse, EditOrderErrorResponse, DeletedOrderErrorResponse],
            needsAuthorization: true
        });
        const articles = [article]
        return this.callEndpoint(endpoint, {orderNumber, articles}, responseHandler);
    }

    orderDetail(orderId, responseHandler) {
        const url = `order/marketplace/${orderId}`
        const endpoint = new Endpoint({
            url: url,
            method: "GET",
            ownResponses: [OrderWithAuthorizationResponse, DeletedOrderErrorResponse],
            needsAuthorization: true
        });
        return this.callEndpoint(endpoint, {}, responseHandler);
    }

    orderPrices(orderId, responseHandler) {
        const url = `order/prices/${orderId}`
        const endpoint = new Endpoint({
            url: url,
            method: "GET",
            ownResponses: [OrderPricesResponse, DeletedOrderErrorResponse],
            needsAuthorization: true
        });
        return this.callEndpoint(endpoint, {}, responseHandler);
    }

    invoicePrices(invoiceNumber, responseHandler) {
        const url = `invoice/prices/${invoiceNumber}`
        const endpoint = new Endpoint({
            url: url,
            method: "GET",
            ownResponses: [OrderPricesResponse],
            needsAuthorization: true
        });
        return this.callEndpoint(endpoint, {}, responseHandler);
    }

    createOrder(order, responseHandler) {
        const endpoint = new CreateOrderEndpoint({
            url: "order/create",
            method: "POST",
            ownResponses: [OrderResponse],
            needsAuthorization: true
        });
        return this.callEndpoint(endpoint, order, responseHandler);
    }

    editOrder(ordersNumber, order, responseHandler) {
        const endpoint = new EditOrderEndpoint({
            url: "order/edit",
            method: "POST",
            ownResponses: [OrderResponse, EditOrderErrorResponse, DeletedOrderErrorResponse],
            needsAuthorization: true
        });
        return this.callEndpoint(endpoint, {ordersNumber, order}, responseHandler);
    }

    returnOrderToInitial(orderNumber, responseHandler) {
        const endpoint = new MarkOrderAsInitialEndpoint({
            url: "order/return-to-initial",
            method: "POST",
            ownResponses: [OrderResponse, DeletedOrderErrorResponse],
            needsAuthorization: true
        });
        return this.callEndpoint(endpoint, orderNumber, responseHandler);
    }

    closeOrder(orderNumber, responseHandler) {
        const endpoint = new MarkOrderAsPendingEndpoint({
            url: "order/close-from-marketplace",
            method: "POST",
            ownResponses: [OrderResponse, EditOrderErrorResponse, DeletedOrderErrorResponse, AdvancePaymentProofErrorResponse],
            needsAuthorization: true
        });
        return this.callEndpoint(endpoint, orderNumber, responseHandler);
    }

    generateCartFromPrompt(orderNumber, businessName, userRequest, responseHandler) {
        const endpoint = new Endpoint({
            url: "shopping-cart/generate-from-prompt",
            method: "POST",
            ownResponses: [OrderResponse, EditOrderErrorResponse, DeletedOrderErrorResponse],
            needsAuthorization: true
        });

        return this.callEndpoint(endpoint, {
            order_number: orderNumber,
            business_name: businessName,
            user_request: userRequest
        }, responseHandler);
    }

    askMarketplaceAssistant(userRequest, businessName, chatHistory, sessionId, responseHandler) {
        const endpoint = new Endpoint({
            url: "assistant/ask",
            method: "POST",
            ownResponses: [AskMarketplaceAssistantResponse],
            needsAuthorization: true
        });

        return this.callEndpoint(endpoint, {
            user_request: userRequest,
            business_name: businessName,
            chat_history: chatHistory,
            session_id: sessionId,
        }, responseHandler);
    }

    userWithRoles(responseHandler, anEmail) {
        const url = `users/${anEmail}`
        const endpoint = new Endpoint({
            url: url,
            method: "GET",
            ownResponses: [UserWithRolesAndPermissionsGrantedResponse],
            needsAuthorization: true
        });
        return this.callEndpoint(endpoint, {}, responseHandler);
    }

    customerTaxProfile(customerBusinessName, responseHandler) {
        const url = `customer/tax-profile/${encodeURIComponent(customerBusinessName)}`
        const endpoint = new Endpoint({
            url: url,
            method: "GET",
            ownResponses: [CustomerTaxProfileResponse],
            needsAuthorization: true
        });
        return this.callEndpoint(endpoint, {}, responseHandler);
    }

    usersDeliverySites(responseHandler, customer) {
        const endpoint = new Endpoint({
            url: `customer/delivery-sites`,
            method: "GET",
            ownResponses: [UsersDeliverySitesResponse],
            needsAuthorization: true
        });
        return this.callEndpoint(endpoint, {'business_name': customer.businessName}, responseHandler);
    }

    getArticlePriceList(responseHandler, customer) {
        const endpoint = new Endpoint({
            url: `customer-article-price-list`,
            method: "GET",
            ownResponses: [GetArticlePriceListResponse],
            needsAuthorization: true
        });
        return this.callEndpoint(endpoint, {'business_name': customer.businessName}, responseHandler);
    }

    checkingAccount(responseHandler, customer) {
        const endpoint = new Endpoint({
            url: `customer/checking-account`,
            method: "GET",
            ownResponses: [CheckingAccountResponse],
            needsAuthorization: true
        });
        return this.callEndpoint(endpoint, {'business_name': customer.businessName}, responseHandler);
    }

    getArticlesCategories(responseHandler, customer) {
        const endpoint = new Endpoint({
            url: `customer-articles-categories`,
            method: "GET",
            ownResponses: [GetArticlesCategoriesResponse],
            needsAuthorization: true
        });
        return this.callEndpoint(endpoint, {'business_name': customer.businessName}, responseHandler);
    }

    getCategoriesArticles(categoryId, customer, responseHandler) {
        const endpoint = new Endpoint({
            url: `category/${categoryId}/priced-articles`,
            method: "GET",
            ownResponses: [GetCategoriesPricedArticlesResponse],
            needsAuthorization: true
        });
        return this.callEndpoint(endpoint, {'business_name': customer.businessName}, responseHandler);
    }

    getEnabledDatesForDeliverySite(deliverySiteCode, customerBusinessName, responseHandler) {
        const url = `delivery_site/${deliverySiteCode}/${customerBusinessName}/enabled-dates`
        const endpoint = new Endpoint({
            url: url,
            method: "GET",
            ownResponses: [GetEnabledDeliveryDatesResponse],
            needsAuthorization: true
        });
        return this.callEndpoint(endpoint, {}, responseHandler);
    }

    existsOrderForSelectedDateAndPurchaseOrder(businessName, deliverySiteCode, deliveryDate, purchaseOrderNumber, responseHandler){
        const url = 'order/exists_same_order'
        const endpoint = new Endpoint({
            url: url,
            method: "GET",
            ownResponses: [ExistsSameOrderResponse],
            needsAuthorization: true
        });
        return this.callEndpoint(endpoint, {"business_name" : businessName,  'delivery_site_code': deliverySiteCode, 'delivery_date': deliveryDate, 'purchase_order_number': purchaseOrderNumber }, responseHandler);
    }

    editOrdersPurchaseOrderNumber(ordersNumber, purchaseOrdersNumber, responseHandler) {
        const endpoint = new EditPurchaseOrderNumberEndpoint({
            url: "order/edit-purchase-order-number",
            method: "POST",
            ownResponses: [OrderResponse, EditOrderErrorResponse, DeletedOrderErrorResponse],
            needsAuthorization: true
        });
        return this.callEndpoint(endpoint, {ordersNumber, purchaseOrdersNumber} , responseHandler);
    }

    deleteOrdersArticle(orderNumber, articleCode, responseHandler) {
        const endpoint = new DeleteOrdersArticleEndpoint({
            url: "order/articles/delete",
            method: "POST",
            ownResponses: [OrderResponse],
            needsAuthorization: true
        });
        return this.callEndpoint(endpoint, {orderNumber, articleCode}, responseHandler);
    }

    async addTicket(name, email, issue, detail, files, token, responseHandler) {
        // FIXME: MISSING IMPLEMENTATION IN ERYXCOM PACKAGE.
        const formData = new FormData();
        formData.append('name', name);
        formData.append('email', email);
        formData.append('issue', issue);
        formData.append('detail', detail);
        for (let i = 0; i < files.length; i++) {
            formData.append('files[]', files[i]); // 'files[]' is the key; your backend must expect this
        }

        const headers = {
            'Authorization': `Bearer ${token}`,
        }

        const response = await fetch(this._application.remoteApiUrl() + '/ticket/add', {
            method: 'POST',
            body: formData,
            headers: headers,
            credentials: 'include',
        });

        // FIXME: this should be replaced with a proper use of ERYXCOM package when it handles multiple files
        if (response.status === 200) {
            responseHandler._handlesSuccess(response)
        } else {
            responseHandler._handlesError(response)
        }
        return response;
    }

    async registerAdvancePaymentProof(orderNumber, file, responseHandler) {
        const token = this._application.session().getToken();
        const formData = new FormData();
        if (file) {
            formData.append('files', file);
        }

        const headers = {
            'Authorization': `Bearer ${token}`,
        }

        const response = await fetch(this._application.remoteApiUrl() + `/order/${orderNumber}/register-advance-payment-proof/`, {
            method: 'POST',
            body: formData,
            headers: headers,
            credentials: 'include',
        });

        // Handle response similar to addTicket pattern
        if (response.status === 200) {
            const responseData = await response.json();
            const successResponse = new AdvancePaymentProofResponse(responseData);
            responseHandler._handlesSuccess(successResponse);
        } else {
            responseHandler._handlesError(response);
        }
        return response;
    }

    async getAdvancePaymentProof(orderNumber, responseHandler) {
        const url = `order/${orderNumber}/advance-payment-proof/`
        const endpoint = new Endpoint({
            url: url,
            method: "GET",
            ownResponses: [AdvancePaymentProofResponse],
            needsAuthorization: true
        });
        return this.callEndpoint(endpoint, {}, responseHandler);
    }
}
